/**
 * Partners Slider
 *
 * @since 1.0.0
 * @package geo_med
 */

(function($) {

    $(document).ready(function() {

        if ($('.video-slider').length) {

            console.log('video slider init');



            $('.video-slider-container').flickity({
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: false,
				draggable: true,
            });

            $('.slider-nav').flickity({
                asNavFor: '.video-slider-container',
				cellAlign: 'left',
                contain: true,
                pageDots: false,
				prevNextButtons: false,
				groupCells: 4,
            });

        }

    });

})(jQuery);
